"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NgDocDeclarations = void 0;
exports.NgDocDeclarations = ['Class', 'Interface', 'Enum', 'Function', 'TypeAlias', 'Variable'];
